import(/* webpackMode: "eager" */ "/codebuild/output/src3915255205/src/src/app/[locale]/page.tsx");
